import React from 'react';
import Crop169Icon from '@mui/icons-material/Crop169';
import AddCircleIcon from '@mui/icons-material/AddCircle';

const AddColumnIcon = ({ direction = 'left' }) => {
	const offset = direction === 'left' ? -4 : 6;
	const columnOffset = direction === 'left' ? 5 : -7;

	const translateX = direction === 'left' ? `calc(-100% - ${offset}px)` : `calc(${offset}px)`;

	return (
		<span
			style={{
				position: 'relative',
				display: 'inline-flex',
				alignItems: 'center',
				justifyContent: 'center',
			}}
		>
			<Crop169Icon
				sx={{
					transform: 'rotate(90deg)',
					display: 'block',
					marginLeft: `${columnOffset}px`,
				}}
				size='small'
			/>

			<AddCircleIcon
				size='small'
				style={{
					position: 'absolute',
					top: '50%',
					transform: `translateY(-50%) translateX(${translateX})`,
					backgroundColor: 'white',
					borderRadius: '50%',
					width: 12,
					height: 12,
					fontSize: '24px',
					pointerEvents: 'none',
				}}
			/>
		</span>
	);
};

export default AddColumnIcon;
